export default "__VITE_ASSET__BhVqyKj5__"